import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const scpConfigService = {
  getAllScpIssuersConfigs,
  getAllEmvProfileCode,
  getAllPersoFormatCode,
};

///==========GET ISSUES CONFIGURATION END POINT=====///
function getAllScpIssuersConfigs(params) {
 
  return apiCall(
    "GET",
    `${API_URLS.SMARTCARDPROCESS.GET_CONFIG_SETUP}`,
    null,
    null,
    params
  );
}

///=======GET EMV PROFILE CODE========///
function getAllEmvProfileCode(params){
  return apiCall(
    "GET",
    `${API_URLS.SMARTCARDPROCESS.GET_EMV_PROFILES}`,
    null,
    null,
    params
  );
}

///=====GET PERSO FORMAT CODE====//
function getAllPersoFormatCode(params){
  return apiCall(
    "GET",
    `${API_URLS.SMARTCARDPROCESS.GET_PERSO_FORMATS}`,
    null,
    null,
    params
  );
}
